import { Module } from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const Plussvr: Module<any, any> = {
  namespaced: true,
  state: {},
  actions,
  getters,
  mutations
}

export default Plussvr
